import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { ProviderConfiguration } from 'src/app/models/provider.interface';

@Injectable({
  providedIn: 'root'
})
export class ProviderService {

  constructor(
    private http: HttpClient
  ) {
    this.provider = {
      publicProviderConfiguration: {},
      environment: 'sandbox'
    };
  }

  public provider: ProviderConfiguration;

  getProviderConfiguration(): Observable<ProviderConfiguration> {
    return this.http.get<ProviderConfiguration>('api/providers/configuration');
  }

  setProviderData(provider: any): void {
    this.provider.publicProviderConfiguration = provider.publicProviderConfiguration;
    this.provider.environment = provider.Environment;
  }
}
